module.exports = __webpack_public_path__ + "media/logo-accedo.b351b3c0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/client/src/images/logo-accedo.svg
// module id = 363
// module chunks = 0